import React from 'react';
import axios from 'axios';
import { Alert, Box, Button, Card, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import Navbar from './Navbar';

const OPTIONS = [
  { value: 'PR', label: 'Complete Flow', detail: 'PR → PO → PD/GRN → PI' },
  { value: 'PO', label: 'Start from Purchase Order', detail: 'PO → PD/GRN → PI' },
  { value: 'PD', label: 'Start from Purchase Delivery', detail: 'PD/GRN → PI' },
  { value: 'PI', label: 'Purchase Invoice Only', detail: 'PI only' },
];

export default function PurchaseWorkflowSettings() {
  const [startStage, setStartStage] = React.useState('PR');
  const [saving, setSaving] = React.useState(false);
  const [resetting, setResetting] = React.useState(false);
  const [resetDialogOpen, setResetDialogOpen] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const api = global.SET_API_URL + 'purchaseWorkflowSettings/';

  React.useEffect(() => {
    axios.get(api).then(({ data }) => setStartStage(data?.data?.startStage || 'PR'))
      .catch(() => setMessage('Purchase workflow settings load nahi ho sakin.'));
  }, [api]);

  const save = async () => {
    setSaving(true); setMessage('');
    try {
      await axios.put(api, { startStage });
      window.dispatchEvent(new Event('purchase-workflow-changed'));
      setMessage('Purchase workflow tamam branches ke liye save ho gaya.');
    } catch (_error) {
      setMessage('Purchase workflow save nahi ho saka.');
    } finally { setSaving(false); }
  };

  const resetPurchaseData = async () => {
    setResetting(true);
    setMessage('');
    try {
      await axios.delete(api + 'reset', { data: { confirmation: 'RESET_PURCHASE_FLOW' } });
      setResetDialogOpen(false);
      setMessage('PR, PO, PD/GRN, PI, Audit aur Manual Issuance data reset ho gaya. Numbering dobara 1 se start hogi.');
    } catch (error) {
      setMessage(error.response?.data?.message || 'Purchase flow data reset nahi ho saka.');
    } finally {
      setResetting(false);
    }
  };

  return <><Navbar /><Box sx={{ p: 3, maxWidth: 760 }}>
    <Typography variant="h4" sx={{ mb: 1 }}>Purchase Workflow Settings</Typography>
    <Typography color="text.secondary" sx={{ mb: 3 }}>Ye selection main aur tamam sub-branches par apply hogi.</Typography>
    {message && <Alert severity={message.includes('ho gaya') ? 'success' : 'error'} sx={{ mb: 2 }}>{message}</Alert>}
    <Card><CardContent>
      <FormControl><RadioGroup value={startStage} onChange={(event) => setStartStage(event.target.value)}>
        {OPTIONS.map((option) => <Box key={option.value} sx={{ mb: 1.5 }}>
          <FormControlLabel value={option.value} control={<Radio />} label={option.label} />
          <Typography variant="body2" color="text.secondary" sx={{ ml: 4 }}>{option.detail}</Typography>
        </Box>)}
      </RadioGroup></FormControl>
      <Box sx={{ mt: 2 }}><Button variant="contained" disabled={saving} onClick={save}>{saving ? 'Saving...' : 'Save Workflow'}</Button></Box>
    </CardContent></Card>
    <Card sx={{ mt: 3, border: '1px solid', borderColor: 'error.light' }}>
      <CardContent>
        <Typography variant='h6' color='error.main'>Reset Purchase, Audit & Issuance Data</Typography>
        <Typography variant='body2' color='text.secondary' sx={{ mt: 1, mb: 2 }}>
          Ye PR, PO, PD/GRN, PI, Audit aur Manual Issuance ke tamam master/detail records permanently delete karega. Manual Issuance ki stock-ledger entries bhi remove hongi aur numbering 1 se restart hogi.
        </Typography>
        <Button variant='outlined' color='error' onClick={() => setResetDialogOpen(true)}>
          Reset All Purchase Data
        </Button>
      </CardContent>
    </Card>
    <Dialog open={resetDialogOpen} onClose={resetting ? undefined : () => setResetDialogOpen(false)} maxWidth='sm' fullWidth>
      <DialogTitle>Purchase, Audit & Issuance Data Reset?</DialogTitle>
      <DialogContent>
        <Alert severity='error' sx={{ mt: 1 }}>
          Is action ko undo nahi kiya ja sakta. Tamam PR, PO, GRN/PD, PI, Audit aur Manual Issuance records delete ho jayenge.
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button disabled={resetting} onClick={() => setResetDialogOpen(false)}>Cancel</Button>
        <Button disabled={resetting} color='error' variant='contained' onClick={resetPurchaseData}>
          {resetting ? 'Resetting...' : 'Yes, Delete All & Reset'}
        </Button>
      </DialogActions>
    </Dialog>
  </Box></>;
}
